import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../../components/Layout/Header/Header";
import Footer from "../../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../../components/Common/ScrollTop";
import OffWrap from "../../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../../components/Common/Breadcumb";
import SearchModal from "../../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../../utils/fetchData";
import Accreditation from "../../../../../components/Common/Accreditation";
import pdf from "../../../../../assets/img/pdf.png";
import { useFontSize } from "../../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../../utils/getDomainData";

const OTPRI_Admissions = () => {
    const [data, setData] = useState([]);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];
    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.admissions, setData);
    }, [currentDomain]);
    console.log("Admissions Data:", data);

    // Function to render rich text content
    const renderRichText = (content) => {
        console.log("Rendering content:", content);
        if (!content || !Array.isArray(content)) return null;
        
        return content.map((block, index) => {
            if (block.type === 'paragraph') {
                return (
                    <p key={index} className="mb-3">
                        {block.children?.map((child, childIndex) => {
                            if (child.type === 'text') {
                                let text = child.text;
                                
                                // Apply formatting
                                if (child.bold) {
                                    text = <strong key={childIndex}>{text}</strong>;
                                }
                                if (child.italic) {
                                    text = <em key={childIndex}>{text}</em>;
                                }
                                if (child.underline) {
                                    text = <u key={childIndex}>{text}</u>;
                                }
                                
                                return text;
                            }
                            return child.text || "";
                        })}
                    </p>
                );
            } else if (block.type === 'list') {
                const ListTag = block.format === 'ordered' ? 'ol' : 'ul';
                
                return (
                    <ListTag key={index} className="features-list">
                        {block.children?.map((listItem, itemIndex) => {
                            if (listItem.type === 'list-item') {
                                return (
                                    <li key={itemIndex}>
                                        {listItem.children?.map((child, childIndex) => {
                                            if (child.type === 'text') {
                                                let text = child.text;
                                                
                                                // Apply formatting
                                                if (child.bold) {
                                                    text = <strong key={childIndex}>{text}</strong>;
                                                }
                                                if (child.italic) {
                                                    text = <em key={childIndex}>{text}</em>;
                                                }
                                                if (child.underline) {
                                                    text = <u key={childIndex}>{text}</u>;
                                                }
                                                
                                                return text;
                                            }
                                            return child.text || "";
                                        })}
                                    </li>
                                );
                            }
                            return null;
                        })}
                    </ListTag>
                );
            }
            return null;
        });
    };

    const admissionsData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>Admissions | Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="Admissions at JNTUA Oil Technological and Pharmaceutical Research Institute (OT&PRI) - Learn about our college, features, and educational excellence."
                />
                <meta
                    name="keywords"
                    content="OTPRI Admissions, Oil Technological, Pharmaceutical Research Institute, JNTUA, College Information"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .about-section {
                        background: #f8f9fa;
                        padding: 40px 0;
                    }
                    .college-section {
                        background: #fff;
                        padding: 50px 0;
                    }
                    .features-section {
                        padding: 50px 0;
                    }
                    .section-heading {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 30px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                        display: inline-block;
                    }
                    .college-intro {
                        font-size: 1.1rem;
                        line-height: 1.8;
                        margin-bottom: 30px;
                        color: #333;
                    }
                    .college-list {
                        list-style: none;
                        padding: 0;
                    }
                    .college-list li {
                        background: #fff;
                        padding: 20px 20px 20px 50px;
                        margin-bottom: 15px;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        border-left: 4px solid #007bff;
                        position: relative;
                    }
                    .college-list li::before {
                        content: "✓";
                        position: absolute;
                        left: 10px;
                        top: 20px;
                        background: #007bff;
                        color: white;
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: bold;
                    }
                    .college-list li:nth-child(2n) {
                        border-left-color: #28a745;
                    }
                    .college-list li:nth-child(2n)::before {
                        background: #28a745;
                    }
                    .college-list li:nth-child(3n) {
                        border-left-color: #dc3545;
                    }
                    .college-list li:nth-child(3n)::before {
                        background: #dc3545;
                    }
                    .features-list {
                        list-style: none;
                        padding: 0;
                        margin-top: 30px;
                    }
                    .features-list li {
                        background: #fff;
                        padding: 20px;
                        margin-bottom: 15px;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        border-left: 4px solid #007bff;
                        position: relative;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .features-list li:hover {
                        transform: translateX(5px);
                        box-shadow: 0 5px 15px rgba(0,0,0,0.15);
                    }
                    .features-list li:nth-child(2n) {
                        border-left-color: #28a745;
                    }
                    .features-list li:nth-child(3n) {
                        border-left-color: #ffc107;
                    }
                    .about-image {
                        border-radius: 15px;
                        overflow: hidden;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                        transition: transform 0.3s ease;
                    }
                    .about-image:hover {
                        transform: scale(1.02);
                    }
                    .about-image img {
                        width: 100%;
                        height: auto;
                        display: block;
                    }
                    .links-section {
                        padding: 40px 0;
                    }
                    .link-card {
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        padding: 25px;
                        height: 100%;
                        border-left: 4px solid #007bff;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .link-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 5px 20px rgba(0,0,0,0.15);
                    }
                    .link-title {
                        color: #333;
                        font-weight: bold;
                        margin-bottom: 15px;
                        font-size: 1.1rem;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                    .link-title img {
                        width: 30px;
                        height: 30px;
                    }
                    .link-button {
                        background: #007bff;
                        border: none;
                        padding: 10px 20px;
                        border-radius: 5px;
                        color: white;
                        text-decoration: none;
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        transition: background-color 0.3s ease;
                    }
                    .link-button:hover {
                        background: #0056b3;
                        color: white;
                        text-decoration: none;
                    }
                    .link-button i {
                        font-size: 16px;
                    }
                    .section-content {
                        margin-top: 20px;
                    }
                `}
            </style>
            <div className="pageTopOffset">
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="About Us"
                    pageName="About Us"
                    breadcrumbsClass="breadcrumb-bg"
                />
                {/* breadcrumb-area-start */}
                {getMenu(currentDomain)}
                
                <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
                    <div className="container">
                        <div className="row">
                            <div className="col pl-20 md-pl-14">
                                <div className="row">
                                    <div className="rs-inner-blog col-lg-12">
                                        {/* Sections */}
                                        {admissionsData?.sections && admissionsData.sections.length > 0 && (
                                            <div className="admissions-sections">
                                                {admissionsData.sections.map((section, sectionIndex) => (
                                                    <div key={section.id || sectionIndex} className="college-section mb-5">
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <h2 className="section-heading">
                                                                    {section.title}
                                                                </h2>
                                                                
                                                                <div className="section-content">
                                                                    {renderRichText(section.content)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* Links Section */}
                                        {admissionsData?.links && admissionsData.links.length > 0 && (
                                            <div className="links-section">
                                                <h2 className="section-heading">
                                                    Important Links
                                                </h2>
                                                
                                                <div className="row">
                                                    {admissionsData.links.map((link, linkIndex) => {
                                                        const pdfUrl = link?.content?.data?.attributes?.url;
                                                        const pdfName = link?.content?.data?.attributes?.name;
                                                        
                                                        return (
                                                            <div key={link.id || linkIndex} className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                                                <div className="link-card">
                                                                    <div className="link-content">
                                                                        <h5 className="link-title">
                                                                            <img src={pdf} alt="PDF" />
                                                                            {link.label}
                                                                        </h5>
                                                                        {pdfUrl && (
                                                                            <a 
                                                                                href={imageBaseURL + pdfUrl} 
                                                                                target="_blank" 
                                                                                rel="noopener noreferrer" 
                                                                                className="link-button btn btn-primary"
                                                                                title={pdfName || link.label}
                                                                            >
                                                                                <i className="fa fa-download"></i>
                                                                                Download PDF
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
};

export default OTPRI_Admissions;